(function () {
  if (document.getElementById('StructuredDataFAQ')) return;

  const questions = [];

  document.querySelectorAll('.collapsible-content .accordion').forEach(function (accordion) {
    const heading = accordion.querySelector('.accordion__title');
    const content = accordion.querySelector('.accordion__content');
    if (!heading || !content) return;

    const name = heading.textContent.replace(/\s+/g, ' ').trim();
    const text = content.textContent.replace(/\s+/g, ' ').trim();
    if (!name || !text) return;

    questions.push({
      '@type': 'Question',
      name: name,
      acceptedAnswer: {
        '@type': 'Answer',
        text: text
      }
    });
  });

  if (questions.length === 0) return;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = 'StructuredDataFAQ';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
})();
